__turbopack_context__.v({
  "nonDiscountedPrice": "styles-module__hcX4Ca__nonDiscountedPrice",
});
